<template>
  <div>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="computedTitle"
      :visible.sync="dialogVisible"
      custom-class="editor-dialog"
      top="30vh"
      :show-close="false"
      :before-close="editClickCanc"
    >
      <el-form :model="dialogInfo" :rules="rules" ref="wordForm">
        <el-form-item>
          <el-input
            v-model="wordVal"
            autocomplete="off"
            class="first-inp"
            ref="firstInp"
            maxlength="10"
          >
            <div slot="prefix" class="input-title">
              {{ $t('hanzi') }}<svg-icon type="xinghao_red" class="xinghao_red"></svg-icon>
            </div>
          </el-input>
        </el-form-item>
        <el-form-item prop="pinyin">
          <el-input
            v-model="dialogInfo.pinyin_num"
            autocomplete="off"
            :disabled="isWordEmpty"
            ref="pinyin"
            :validate-event="false"
            oninput="value=value.replace(/[^a-zA-Z0-9\s]/g,'')"
            class="pinyin"
          >
            <div slot="prefix" class="input-title">
              {{ $t('vocab_pinyin') }}<svg-icon type="xinghao_red" class="xinghao_red"></svg-icon>
            </div>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dialogInfo.translation"
            filterable
            placeholder=""
            allow-create
            default-first-option
            :disabled="isWordEmpty"
            popper-class="translate-select"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.translation"
              :value="item.translation"
            >
            </el-option>
            <div slot="prefix" class="input-title translate-inp">
              {{ $t('vocab_translate')
              }}<svg-icon type="xinghao_red" class="xinghao_red"></svg-icon>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dialogInfo.vocab_type"
            filterable
            placeholder=""
            :disabled="isWordEmpty"
            popper-class="translate-select"
          >
            <el-option
              v-for="item in vocabTypeOption"
              :key="item.Id"
              :label="item.Syntax"
              :value="item.Syntax"
            >
            </el-option>
            <div slot="prefix" class="input-title translate-inp">
              {{ $t('vocab_type') }}
            </div>
          </el-select>
        </el-form-item>

        <el-form-item class="dialog-footer">
          <el-button class="button canc-button" @mousedown.native="editClickCanc()">{{
            $t('cancel')
          }}</el-button>
          <el-button
            type="primary"
            class="button save-button"
            @mousedown.native="editClickSave()"
            :disabled="isHasEmpty"
            :class="{ disable: isHasEmpty }"
            >{{ $t('save') }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ApiPath from '@/serves/path'
import { apiRequest, utilV2 } from '@/serves/http'
export default {
  props: {
    editorDialogVisible: {
      type: Boolean,
      default: false,
    },
    editorDialogInfo: {
      type: Object,
    },
    dialogType: {
      type: Number,
      default: 1,
    },
    editorWord: {
      type: String,
      default: '',
    },
  },
  data() {
    let validatePinyin = (rule, value, callback) => {
      let newWord = ''
      if (this.dialogInfo.word) {
        newWord = this.dialogInfo.word
      }
      // 验证拼音长度
      //多个空格替换成一个
      this.dialogInfo.pinyin_num = this.dialogInfo.pinyin_num.replace(/\s+/gi, ' ')
      var kong = this.dialogInfo.pinyin_num.trim().match(/ /g) //筛选\
      var pinyinLength = 1
      if (kong) {
        pinyinLength = kong.length + 1
      }
      console.log(this.dialogInfo.word, pinyinLength)
      if (pinyinLength !== newWord.length) {
        callback(new Error(this.$t('length_diff')))
        this.$refs.pinyin.focus()
      } else {
        callback()
      } // 一定要每种情况都执行回调
    }
    return {
      dialogVisible: false,
      dialogInfo: {
        id: undefined,
        word: '',
        pinyin_num: '',
        translation: '',
        vocab_type: '',
      },
      level_id: 1,
      //options
      options: [],
      value: '',
      rules: {
        pinyin: [{ validator: validatePinyin }],
      },
      formatWord: '',
      wordVal: '',
      vocabTypeOption: [],
    }
  },

  computed: {
    computedTitle() {
      if (this.dialogType === 1) {
        return this.$t('add_vocab')
      } else {
        return this.$t('edit_vocab')
      }
    },
    // 汉字是否为空
    isWordEmpty() {
      if (!this.dialogInfo.word) {
        return true
      } else {
        return false
      }
    },
    // 汉字拼音翻译是否有空的
    isHasEmpty() {
      if (this.dialogInfo.word && this.dialogInfo.pinyin_num && this.dialogInfo.translation) {
        return false
      } else {
        return true
      }
    },
  },

  watch: {
    //内容变化
    editorDialogInfo: {
      handler(newVal) {
        console.log('newVal+++++++=========++++++++=====', newVal)
        this.dialogInfo.id = newVal.id
        this.dialogInfo.word = newVal.word
        this.dialogInfo.pinyin_num = newVal.pinyin_num
        this.dialogInfo.translation = newVal.translation
        this.dialogInfo.vocab_type = newVal.syntax
        this.wordVal = newVal.word
      },
    },
    wordVal: {
      handler(newVal) {
        //只剩下汉字
        if (newVal) {
          this.wordVal = newVal.replace(/[^\u4e00-\u9fa5]/g, '')
          console.log(this.dialogInfo.word, newVal, '字词')
          if (this.dialogInfo.word === newVal.replace(/[^\u4e00-\u9fa5]/g, '')) {
            console.log('一样的')
            return
          } else {
            this.dialogInfo.word = this.wordVal
            console.log('请求了')
            this.initInput()
            this.remainder()
          }
        } else {
          this.initInput()
          console.log('空了', this.dialogInfo.pinyin_num, this.dialogInfo.translation)
          this.dialogInfo.word = this.wordVal = newVal
        }
      },
    },
    editorDialogVisible: {
      handler(newVal) {
        this.dialogVisible = newVal
      },
      immediate: true,
    },
    '$route.query.id': {
      handler(val) {
        this.level_id = Number(val) || Number(localStorage.getItem('LevelActive'))
      },
      immediate: true,
    },
  },

  methods: {
    initInput() {
      this.dialogInfo.pinyin_num = ''
      this.dialogInfo.translation = ''
      this.dialogInfo.vocab_type = ''
      this.options = []
    },
    editClickCanc() {
      this.$emit('cancClick')
      this.$refs.wordForm.resetFields()
      this.options = []
    },
    editClickSave() {
      this.$refs.wordForm.validate((valid) => {
        if (valid) {
          if (this.dialogType === 1) {
            const selectedOption = this.options.find((item) => {
              return item.translation === this.dialogInfo.translation
            })
            const params = {
              level_id: this.level_id,
              word: this.dialogInfo.word,
              pinyin_num: this.dialogInfo.pinyin_num,
              translation: this.dialogInfo.translation,
              syntax: this.dialogInfo.vocab_type,
            }
            //如果是选择的翻译，添加参数translation_id
            if (selectedOption) {
              params.translation_id = selectedOption.id
            }
            console.log(params)
            //创建词汇接口
            apiRequest
              .post(ApiPath.create_word, params, { loading: true })
              .then((res) => {
                console.log(res)
                this.$emit('addClick')
                this.$message({
                  message: this.$t('add_word_success'),
                  type: 'success',
                })
              })
              .catch((res) => {
                console.log(res)
                this.$message.error(res || this.$t('add_word_fail'))
              })
          } else {
            // 编辑词汇
            const selectedOption = this.options.find((item) => {
              return item.translation === this.dialogInfo.translation
            })
            const params = {
              id: this.dialogInfo.id,
              word: this.dialogInfo.word,
              pinyin_num: this.dialogInfo.pinyin_num,
              translation: this.dialogInfo.translation,
              syntax: this.dialogInfo.vocab_type,
            }
            if (selectedOption) {
              params.translation_id = selectedOption.id
            }
            console.log(params)

            //编辑词汇接口
            apiRequest
              .post(ApiPath.update_word, params, { loading: true })
              .then((res) => {
                console.log(res)
                this.$emit('editClick')
                this.$message({
                  message: this.$t('edit_word_success'),
                  type: 'success',
                })
              })
              .catch((res) => {
                this.$message.error(res || this.$t('edit_word_fail'))
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    //  自动匹配拼音和翻译
    remainder() {
      console.log('this.editorDialogInfo:', this.editorDialogInfo)
      const params1 = {
        word: this.dialogInfo.word,
      }
      console.log(this.dialogInfo.word)
      if (this.dialogInfo.word) {
        utilV2.getData(ApiPath.get_vocab_types, {}, (res) => {
          console.log('词性列表', res)
          this.vocabTypeOption = res
          this.vocabTypeOption.unshift('')
        })
        this.dialogInfo.vocab_type = this.editorDialogInfo.syntax
        utilV2.getData(ApiPath.get_pinyin, params1, (res) => {
          console.log(res)
          if (res.length > 0) {
            this.dialogType === 2 && this.dialogInfo.word === this.editorDialogInfo.word
              ? (this.dialogInfo.pinyin_num = this.editorDialogInfo.pinyin_num)
              : (this.dialogInfo.pinyin_num = res[0].pinyin_num)
          } else {
            this.dialogInfo.pinyin_num = ''
          }
        })
        utilV2.getData(ApiPath.get_translate, params1, (res) => {
          console.log(res, 'translate')
          if (res.length > 0) {
            this.options = res
            if (!this.dialogInfo.translation) {
              //如果是编辑词汇的话，并且词汇内容不改变的话，input显示的默认拼音和翻译是词汇表中的，不是提示的
              //词汇内容改变的话input才显示提示的内容(翻译同)
              this.dialogType === 2 && this.dialogInfo.word === this.editorDialogInfo.word
                ? (this.dialogInfo.translation = this.editorDialogInfo.translation)
                : (this.dialogInfo.translation = this.options[0].translation)
            }
          } else {
            this.dialogInfo.translation = ''
            this.options = []
          }
        })
        console.log('options', this.options)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.input-title {
  font-weight: 500;
  font-size: 16px;
  color: #b5b5be;
  padding-left: 20px;
  .xinghao_red {
    width: 5px;
    height: 5px;
    position: absolute;
    top: 10px;
  }
}
::v-deep .editor-dialog {
  width: 432px;
  height: 380px;
  border-radius: 12px;
  .el-dialog__body {
    padding-top: 6px;
    padding-bottom: 4px;
  }
  .el-form-item__error {
    padding-left: 65px;
  }
  .el-dialog__title {
    font-weight: 600;
  }
  .el-input--prefix {
    .el-input__inner {
      width: 400px;
      border-radius: 6px;
      padding-left: 170px;
      border: none;
      background: #fafafb;
      &:focus {
        border: 1px solid #515571;
        background: #ffffff;
      }
      &.error {
        border: 1px solid #f56c6c !important;
      }
    }
  }
  .dialog-footer {
    margin-left: 190px;
    padding-top: 8px;
    .button {
      width: 94px;
      height: 44px;
      border-radius: 4px;
      &.canc-button {
        background: #efeff1;
        border: none;
        &:hover {
          color: #606266;
        }
      }
      &.save-button {
        background: #faae56;
        color: #fff;
        border: none;
        // &.disable {
        //   background-color: #e7e7ed;
        //   color: #696974;
        // }
      }
    }
  }
}
</style>
